import ContactDomain from '../../domains/ContactDomain'
import AccountNumbersDomain from '../../domains/AccountNumbersDomain'
import TireDomain from '../../domains/TireDomain'
import WheelDomain from '../../domains/WheelDomain'
import PoPreferenceDomain from '../../domains/PoPreferenceDomain'

export const load = (fleetLocation, state, billToContacts, billToInfo) => {
	let object = {}

	let billTo = []
	if (billToContacts && billToContacts.length > 0) {

		billTo = billToContacts
			.map(item => {
				const contact = item.contact

				const billToDomain = new ContactDomain(
					contact.name, 
					contact.title,
					getPhoneNumberFromContact(contact), 
					contact.email, 
					contact.id,
					getPhoneNumberIdFromContact(contact), 
					contact.contactTypes.map(c => c.name),
					contact.contactTypes.map(c => c.priority).reduce((prev, cur) => prev < cur ? prev : cur, Number.MAX_SAFE_INTEGER),
					contact.notifyWhenRolling, 
					contact.notifyWhenDispatched, 
					true, 
					contact.createdAt, 
					contact.updatedAt)

				return billToDomain
			})
			.sort((a, b) => {
				if (a.priority > b.priority) return 1
				if (a.priority < b.priority) return -1

				return a.contactPrimaryName.localeCompare(b.contactPrimaryName)
			})
	}

	object.contacts = billTo.concat(fleetLocation.contacts
		.map(contact => {
			const contactDomain = new ContactDomain(
				contact.name, 
				contact.title,
				getPhoneNumberFromContact(contact), 
				contact.email, 
				contact.id,
				getPhoneNumberIdFromContact(contact), 
				contact.contactTypes.map(c => c.name),
				contact.contactTypes.map(c => c.priority).reduce((prev, cur) => prev < cur ? prev : cur, Number.MAX_SAFE_INTEGER),
				contact.notifyWhenRolling, 
				contact.notifyWhenDispatched, 
				false, 
				contact.createdAt, 
				contact.updatedAt)

			return contactDomain
		})
		.sort((a, b) => {
			if (a.priority > b.priority) return 1
			if (a.priority < b.priority) return -1

			return a.contactPrimaryName.localeCompare(b.contactPrimaryName)
		}))

	if (!object.contacts || object.contacts.length === 0) {
		object.contacts = []
	}

	object.newOtherAccounts = fleetLocation.otherAccounts
		.sort((a,b) => { 
			if (a.otherAccountTypeId > b.otherAccountTypeId) return 1
			if (a.otherAccountTypeId < b.otherAccountTypeId) return -1

			if (a.name > b.name) return 1
			if (a.name < b.name) return -1

			if (a.accountNumber > b.accountNumber) return 1
			if (a.accountNumber < b.accountNumber) return -1
			
			return 0
		})
		.map(a => {
			return new AccountNumbersDomain(a.otherAccountTypeId, a.name, a.accountNumber, a.id, false, false, a.createdAt, a.updatedAt)
		})

	if (!object.newOtherAccounts || object.newOtherAccounts.length === 0) {
		if (fleetLocation.locationType.name === 'Shipping') {
			const billToOtherAccounts = billToInfo.otherAccounts.map(a => {
				return new AccountNumbersDomain(a.otherAccountTypeId, a.name, a.accountNumber, a.id, true, true, a.createdAt, a.updatedAt)
			})
			object.newOtherAccounts = billToOtherAccounts
		} else {
			object.newOtherAccounts = []
		}
	}

	object.newHomePage = state.homePageDomain
	object.newHomePage.id = fleetLocation.id
	object.newHomePage.fleetId = fleetLocation.fleetId
	object.newHomePage.ersInstructions = fleetLocation.ersComments

	object.ersInstructions = fleetLocation.ersComments

	let poPref = fleetLocation.billingPreference
	let poPreference = new PoPreferenceDomain(false, false, '2', 0, false, true, null, null)

	if (poPref !== null) {
		poPreference = new PoPreferenceDomain(
			poPref.poRequired,
			poPref.poRequiredBefore !== undefined ? poPref.poRequiredBefore : false, 
			(poPref.creditCardRulesId !== null) ? poPref.creditCardRulesId.toString() : '2',
			fleetLocation.billingPreferenceId,
			false,
			true,
			poPref.createdAt,
			poPref.updatedAt)
	} else {
		if (fleetLocation.locationType.name === 'Shipping') {
			let billToPoPref = billToInfo.billingPreference

			if (billToPoPref !== null) {
				poPreference = new PoPreferenceDomain(
					billToPoPref.poRequired !== null ? billToPoPref.poRequired : false,
					billToPoPref.poRequiredBefore !== undefined ? billToPoPref.poRequiredBefore : false,
					(billToPoPref.creditCardRulesId !== null) ? billToPoPref.creditCardRulesId.toString() : '2',
					billToInfo.billingPreferenceId,
					true,
					true,
					billToPoPref.updatedAt,
					billToPoPref.createdAt
				)
			}
		}
	}
	object.poPreference = poPreference

	object.accountType = fleetLocation.hasOwnProperty('localAccounts') ? 'LBB' : 'NAFA'

	object.address = fleetLocation.address

	let fleetLocationIdentifier = ''
	if (fleetLocation.address.address) {
		fleetLocationIdentifier += fleetLocation.address.address + ' '
	}
	if (fleetLocation.address.address2) {
		fleetLocationIdentifier += fleetLocation.address.address2 + ' '
	}
	if (fleetLocation.address.city) {
		fleetLocationIdentifier += fleetLocation.address.city + ', '
	}
	if (fleetLocation.address.state) {
		fleetLocationIdentifier += fleetLocation.address.state + ' '
	}
	if (fleetLocation.address.zip) {
		fleetLocationIdentifier += fleetLocation.address.zip + ' '
	}
	object.fleetLocationIdentifier = fleetLocationIdentifier

	if (fleetLocation.locationType.name === 'Shipping') {
		object.shipTo = fleetLocation.accountNumber
		if (fleetLocation.parent) {
			object.billTo = fleetLocation.parent.accountNumber
		}

	}
	else if (fleetLocation.locationType.name === 'Billing') {
		object.billTo = fleetLocation.accountNumber
	}

	object.isShipTo = !!fleetLocation.isShipTo
	object.isBillTo = !!fleetLocation.isBillTo

	let newTires = []
	if (fleetLocation.axleTirePreference && fleetLocation.axleTirePreference.axleTireDetails) {
		newTires = fleetLocation.axleTirePreference.axleTireDetails.filter(tp => !!tp.isErs).map(t => {
			return new TireDomain(
				t.axleTypeId, 
				t.priority, 
				t.tireApplicationId, 
				'Await Verbal Instruction', 
				t.isRetread, 
				t.brandId, 
				t.sizeId, 
				t.size.name, 
				t.treadId, 
				t.loadRangeId, 
				t.id, 
				fleetLocation.id, 
				t.comments, 
				t.isErs, 
				!(fleetLocation.locationType.name === 'Shipping'), 
				!!fleetLocation.isBillTo, 
				t.createdAt, 
				t.updatedAt)
		})
	}

	if (newTires.length === 0) {
		if (fleetLocation.locationType.name === 'Shipping') {
			if (billToInfo.axleTirePreference && billToInfo.axleTirePreference.axleTireDetails) {
				newTires = billToInfo.axleTirePreference.axleTireDetails.filter(tp => !!tp.isErs).map(t => {
					return new TireDomain(
						t.axleTypeId, 
						t.priority, 
						t.tireApplicationId, 
						'Await Verbal Instruction', 
						t.isRetread, 
						t.brandId, 
						t.sizeId, 
						t.size.name, 
						t.treadId, 
						t.loadRangeId, 
						t.id, 
						fleetLocation.id, 
						t.comments, 
						t.isErs, 
						true, 
						true, 
						t.createdAt, 
						t.updatedAt)
				})
			}
		} else {
			newTires = []
		}

	}

	object.newTires = newTires
	let newWheels = []

	if (fleetLocation.axleWheelPreference && fleetLocation.axleWheelPreference.axleWheelDetails) {
		newWheels = fleetLocation.axleWheelPreference.axleWheelDetails.map(w => {
			// const datWheel = new WheelDomain(w.wheelDiameterId, w.wheelOffset, w.wheelMaterialId, w.wheelTypeId, w.color, w.comments, w.id, !(fleetLocation.locationType.name === 'Shipping'), !!fleetLocation.isBillTo, w.createdAt, w.updatedAt)
			// datWheel.isCreate = false
			// datWheel.readOnly =  !!fleetLocation.isBillTo
			return new WheelDomain(w.wheelDiameterId, w.wheelOffset === null ? -1 : w.wheelOffset, w.wheelMaterialId, w.wheelTypeId, w.color, w.comments, w.id, !(fleetLocation.locationType.name === 'Shipping'), !!fleetLocation.isBillTo, w.createdAt, w.updatedAt)
		})
	}

	if (newWheels.length === 0) {
		if (fleetLocation.locationType.name === 'Shipping') {
			if (billToInfo.axleWheelPreference && billToInfo.axleWheelPreference.axleWheelDetails) {
				newWheels = billToInfo.axleWheelPreference.axleWheelDetails.map(w => {
					// const datWheel = new WheelDomain(w.wheelDiameterId, w.wheelOffset, w.wheelMaterialId, w.wheelTypeId, w.color, w.comments, w.id, true, !!fleetLocation.isBillTo, w.createdAt, w.updatedAt)
					// datWheel.isCreate = false
					// datWheel.readOnly =  !!fleetLocation.isBillTo
					return new WheelDomain(w.wheelDiameterId, w.wheelOffset === null ? -1 : w.wheelOffset, w.wheelMaterialId, w.wheelTypeId, w.color, w.comments, w.id, true, !!fleetLocation.isBillTo, w.createdAt, w.updatedAt)
				})
			}

		} else {
			newWheels = []
		}
	}
	object.newWheels = newWheels
	object.authorizationPreference =  (fleetLocation.authorizationPreferenceId !== null) ? fleetLocation.authorizationPreferenceId : 1
	object.disposition = 9
	if (fleetLocation.axleCheckPreference && fleetLocation.axleCheckPreference.axleCheckDetails) {
		object.disposition = fleetLocation.axleCheckPreference.axleCheckDetails[0].dispositionId
	}

	return object
}

const getPhoneNumberFromContact = (contact) => {
	if (contact.contactNumbers && contact.contactNumbers.length > 0) {
		return contact.contactNumbers[0].number
	} else {
		return ''
	}
}

const getPhoneNumberIdFromContact = (contact) => {
	if (contact.contactNumbers && contact.contactNumbers.length > 0) {
		return contact.contactNumbers[0].id
	} else {
		return ''
	}
}


// WEBPACK FOOTER //
// ./src/reducers/util/loadPref.js